import { z } from 'zod';

// ID-009 remediation: a user cannot hold both LabManager and LabTechnician
// roles at the same time (RBAC privilege-escalation).
const mutuallyExclusiveRoles = (v: { LabManager: boolean; LabTechnician: boolean }) =>
  !(v.LabManager && v.LabTechnician);
const ROLE_CONFLICT_MSG = 'A user cannot be both LabManager and LabTechnician';

export const LaboratoryUserSchema = z
  .object({
    LaboratoryId: z.string().uuid(),
    UserId: z.string().uuid(),
    OrganizationId: z.string().uuid(),
    Status: z.enum(['Active', 'Inactive']),
    LabManager: z.boolean(),
    LabTechnician: z.boolean(),
    CreatedAt: z.string().optional(),
    CreatedBy: z.string().optional(),
    ModifiedAt: z.string().optional(),
    ModifiedBy: z.string().optional(),
  })
  .strict()
  .refine(mutuallyExclusiveRoles, { message: ROLE_CONFLICT_MSG, path: ['LabManager'] });

export const AddLaboratoryUserSchema = z
  .object({
    LaboratoryId: z.string().uuid(),
    UserId: z.string().uuid(),
    Status: z.enum(['Active', 'Inactive']),
    LabManager: z.boolean(),
    LabTechnician: z.boolean(),
  })
  .strict()
  .refine(mutuallyExclusiveRoles, { message: ROLE_CONFLICT_MSG, path: ['LabManager'] });

export const EditLaboratoryUserSchema = z
  .object({
    LaboratoryId: z.string().uuid(),
    UserId: z.string().uuid(),
    Status: z.enum(['Active', 'Inactive']),
    LabManager: z.boolean(),
    LabTechnician: z.boolean(),
  })
  .strict()
  .refine(mutuallyExclusiveRoles, { message: ROLE_CONFLICT_MSG, path: ['LabManager'] });
export type EditLaboratoryUser = z.infer<typeof EditLaboratoryUserSchema>;

export const RemoveLaboratoryUserSchema = z
  .object({
    LaboratoryId: z.string().uuid(),
    UserId: z.string().uuid(),
  })
  .strict();

export const RequestLaboratoryUserSchema = z
  .object({
    LaboratoryId: z.string().uuid(),
    UserId: z.string().uuid(),
  })
  .strict();
